<template>
   <div>
      <div class="heading text-uppercase">{{ data.header }}</div>
      <ul class="list-unstyled">
         <li v-for="(item, index) in data.items" :key="index">
            <!-- <router-link

               :to="item.link ? item.link : '#'"
            >
               {{ item.header }}
            </router-link> -->
            <a
               :href="item.link ? item.link : '#'"
               :target="isTargetBlank(item) ? '_blank' : 'self'"
               rel="noopener noreferrer"
            >
               {{ item.header }}
            </a>
         </li>
      </ul>
   </div>
</template>

<script>
export default {
   props: {
      data: {
         type: Object,
         default: () => null,
      },
   },
   methods: {
      isTargetBlank(item) {
         const data = item.externalProperties;
         return data && data.openInNewTab;
      },
   },
};
</script>

<style></style>
